<template>
    <div id="app" class="container">
        <headerComponent></headerComponent>


        <router-view :key="$route.path"></router-view>


        <div v-if="errors && errors.length">
            <p class="text-warning" v-for="error of errors" :key="error.message">
                {{ error.message }}
            </p>
        </div>
        <footerComponent></footerComponent>

<!-- SBTP
<iframe :src="this.$store.state.servedByURL" style="position: absolute; visibility: hidden; width: 1px; height: 1px;"></iframe>
-->
    </div>
</template>
<style lang="scss">
    @import 'styles/bootstrap/bootstrap';
    @import 'styles/components/page-basics';
    @import 'styles/components/header';
    @import 'styles/components/footer';
    @import 'styles/components/profile';
    @import 'styles/components/register-full';
</style>
<script>
    import headerComponent from './components/page-basics/header';
    import footerComponent from './components/page-basics/footer';

    export default {
        name: 'app',
        components: {
            headerComponent,
            footerComponent
        },

        computed: {
            errors: function () {
                return this.$store.state.errors;
            }
        },
        methods: {
            logOut() {
                this.$store.commit('login', false);
            }
        }
    };
</script>
